module.exports = __webpack_public_path__ + "static/media/server_side_ad_insertion.ba37d5c4.svg";